import { render, staticRenderFns } from "./CoreVersion.vue?vue&type=template&id=024e72ea"
import script from "./CoreVersion.vue?vue&type=script&lang=js"
export * from "./CoreVersion.vue?vue&type=script&lang=js"
import style0 from "./CoreVersion.vue?vue&type=style&index=0&id=024e72ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports